module.exports = __webpack_public_path__ + "img/expenses_report.99132df5.png";